import { useCallback, useEffect, useState } from "react";
import { AddressDetailsCard } from "@/components/profile-cards";
import type { IClient } from "@/types/users-clients";
import { useBoolean } from "@/ui-kit";
import EditModal from "./EditModal";

type IProps = {
  profile: IClient;
};

const AddressDetails = ({ profile }: IProps) => {
  const [values, setValues] = useState<IClient | null>(profile);

  useEffect(() => {
    if (profile) {
      setValues(profile);
    }
  }, [profile]);

  const updateValues = useCallback((updatedClient: IClient) => {
    setValues(updatedClient);
  }, []);

  const {
    value: showEditModal,
    setTrue: openEditModal,
    setFalse: dismissEditModal,
  } = useBoolean(false);

  const currentProfile = values || profile;

  return (
    <>
      <AddressDetailsCard
        address={currentProfile.address}
        onEdit={openEditModal}
      />
      {showEditModal && (
        <EditModal
          client={currentProfile}
          onSave={updateValues}
          onDismiss={dismissEditModal}
        />
      )}
    </>
  );
};

export default AddressDetails;
